export const SIDEBAR_WIDTH = 220
export const SMALL_SIDEBAR_WIDTH = 60
